import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhCnLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import elementThLocale from 'element-ui/lib/locale/lang/th' // element-ui lang
import enLocale from './en'
import zhCnLocale from './zh-CN'
import thLocale from './th'
import enBizLocale from './en/index'
import zhCnBizLocale from './zh-CN/index'
import thBizLocale from './th/index'
import { project_env } from 'src/config/config'
import { set } from 'nprogress'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
    ...enBizLocale
  },
  'zh_CN': {
    ...zhCnLocale,
    ...elementZhCnLocale,
    ...zhCnBizLocale
  },
  th: {
    ...thLocale,
    ...elementThLocale,
    ...thBizLocale
  }
}
// console.log(`~ messages`, messages)

export function getLanguage() {
  const chooseLanguage = Cookies.get(project_env + 'language')
  if (chooseLanguage) {
    Cookies.set(project_env + 'language', chooseLanguage)
    return chooseLanguage
  }

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      let result = locale.replace('-', '_')
      Cookies.set(project_env + 'language', result)
      return result
    }
  }
  Cookies.set(project_env + 'language', 'en')
  return 'en'
}
// console.log('LanguageObj-->', messages)
const i18n = new VueI18n({
  silentTranslationWarn: true, // 取消本地化失败时输出的警告
  locale: getLanguage(),
  messages,
});

export function changeLangTextArea() {
  const currentLang = getLanguage();
  console.log("currentLang", currentLang)
  if (currentLang === "en") {
    XHEDITOR.setLang({
      default: "Default",
      none: "None",
      defaultReadTip:
        "WYSIWYG Editor,press alt+1-9,toogle to tool area,press tab,select button,press esc,return editor",

      Cut: "Cut (Ctrl+X)",
      Copy: "Copy (Ctrl+C)",
      Paste: "Paste (Ctrl+V)",
      Pastetext: "Paste as plain text",
      PastetextTip: "Use Ctrl+V on your keyboard to paste the text.",
      Blocktag: "Block tag",
      Fontface: "Font family",
      FontSize: "Font size",
      Bold: "Bold (Ctrl+B)",
      Italic: "Italic (Ctrl+I)",
      Underline: "Underline (Ctrl+U)",
      Strikethrough: "Strikethrough",
      FontColor: "Select text color",
      BackColor: "Select background color",
      SelectAll: "SelectAll (Ctrl+A)",
      Removeformat: "Remove formatting",
      Align: "Align",
      List: "List",
      Outdent: "Outdent",
      Indent: "Indent",
      Link: "Insert/edit link (Ctrl+L)",
      Unlink: "Unlink",
      Anchor: "Anchor",
      Img: "Insert/edit image",
      Flash: "Insert/edit flash",
      Media: "Insert/edit media",
      Hr: "Horizontal rule",
      Emot: "Emotions",
      Table: "Insert a new table",
      Source: "Edit source code",
      WYSIWYG: "WYSIWYG mode",
      Preview: "Preview",
      Print: "Print (Ctrl+P)",
      Fullscreen: "Toggle fullscreen (Esc)",
      About: "About xhEditor",

      dialogOk: "Ok",
      dialogCancel: "Cancel",
      cutDisabledTip:
        "Currently not supported by your browser, use keyboard shortcuts(Ctrl+X) instead.",
      copyDisabledTip:
        "Currently not supported by your browser, use keyboard shortcuts(Ctrl+C) instead.",
      pasteDisabledTip:
        "Currently not supported by your browser, use keyboard shortcuts(Ctrl+V) instead.",
      close: "Close",

      listFontname: [
        { n: "Arial" },
        { n: "Arial Black" },
        { n: "Comic Sans MS" },
        { n: "Courier New" },
        { n: "System" },
        { n: "Times New Roman" },
        { n: "Tahoma" },
        { n: "Verdana" },
      ],

      listBlocktag: {
        p: "Paragraph",
        h1: "Heading 1",
        h2: "Heading 2",
        h3: "Heading 3",
        h4: "Heading 4",
        h5: "Heading 5",
        h6: "Heading 6",
        pre: "Preformatted",
        address: "Address",
      },

      fontsize: {
        "x-small": "1",
        small: "2",
        medium: "3",
        large: "4",
        "x-large": "5",
        "xx-large": "6",
        "-webkit-xxx-large": "7",
      },

      align: {
        justifyleft: "Align left",
        justifycenter: "Align center",
        justifyright: "Align right",
        justifyfull: "Align full",
      },

      list: {
        insertOrderedList: "Ordered list",
        insertUnorderedList: "Unordered list",
      },

      link: {
        url: "Link URL: ",
        target: "Target:&nbsp;&nbsp; ",
        targetBlank: "New window",
        targetSelf: "Same window",
        targetParent: "Parent window",
        linkText: "Link Text:",
        defText: "Click here",
        anchor: "Anchor: &nbsp;&nbsp;",
        anchorNone: "None selected",
      },

      anchor: {
        name: "Anchor name: ",
      },

      img: {
        url: "Img URL:&nbsp; ",
        alt: "Alt text: ",
        align: "Alignment:",
        alignLeft: "Left",
        alignRight: "Right",
        alignTop: "Top",
        alignMiddle: "Middle",
        alignBaseline: "Baseline",
        alignBottom: "Bottom",
        width: "Width:&nbsp; &nbsp; ",
        height: "Height:&nbsp; &nbsp;",
        border: "Border:&nbsp; &nbsp;",
        hspace: "Hspace:&nbsp;&nbsp;&nbsp;",
        vspace: "Vspace:&nbsp; &nbsp;",
      },

      flash: {
        url: "Flash URL:",
        width: "Width:&nbsp; &nbsp; ",
        height: "Height:&nbsp; &nbsp;",
      },

      media: {
        url: "Media URL:",
        width: "Width:&nbsp; &nbsp; ",
        height: "Height:&nbsp; &nbsp;",
      },

      "emot.default": {
        smile: "Smile",
        tongue: "Tongue",
        titter: "Titter",
        laugh: "Laugh",
        sad: "Sad",
        wronged: "Wronged",
        fastcry: "Fast cry",
        cry: "Cry",
        wail: "Wail",
        mad: "Mad",
        knock: "Knock",
        curse: "Curse",
        crazy: "Crazy",
        angry: "Angry",
        ohmy: "Oh my",
        awkward: "Awkward",
        panic: "Panic",
        shy: "Shy",
        cute: "Cute",
        envy: "Envy",
        proud: "Proud",
        struggle: "Struggle",
        quiet: "Quiet",
        shutup: "Shut up",
        doubt: "Doubt",
        despise: "Despise",
        sleep: "Sleep",
        bye: "Bye",
      },

      table: {
        rows: "Rows:&nbsp; &nbsp; &nbsp; &nbsp;",
        columns: "Cols:&nbsp; &nbsp; &nbsp; &nbsp;",
        headers: "Headers:&nbsp; &nbsp;&nbsp;",
        headersRow: "First row",
        headersCol: "First column",
        headersBoth: "Both",
        width: "Width: &nbsp; &nbsp; &nbsp;",
        height: "Height:&nbsp; &nbsp; &nbsp;",
        border: "Border:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
        cellSpacing: "CellSpacing:",
        cellPadding: "CellPadding:",
        align: "Align:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
        alignLeft: "Left",
        alignCenter: "Center",
        alignRight: "Right",
        caption: "Caption:&nbsp;&nbsp;&nbsp;&nbsp;",
      },

      upload: {
        btnText: "Upload",
        browserTitle: "Browser file",
        progressTitle: "File uploading(Esc cancel)",
        progressTip: "File uploading,please wait...",
        countLimit: "Please do not upload more then {$0} files.",
        extLimit: "Upload file extension required for this: {$0}",
        typeLimit: "You can only drag and drop the same type of files.",
        apiError:
          "{$0} upload interface error!\r\n\r\nreturn error:\r\n\r\n{$1}",
      },

      aboutXheditor:
        'xhEditor is a platform independent WYSWYG XHTML editor based by jQuery,released as Open Source under <a href="http://www.gnu.org/licenses/lgpl.html" target="_blank">LGPL</a>.',
    });
  } else {
    XHEDITOR.setLang({
      default: "默认",
      none: "无",
      defaultReadTip:
        "可视化编辑器,alt+1到9键,切换到工具区,tab键,选择按钮,esc键,返回编辑",

      Cut: "剪切 (Ctrl+X)",
      Copy: "复制 (Ctrl+C)",
      Paste: "粘贴 (Ctrl+V)",
      Pastetext: "粘贴文本",
      PastetextTip: "使用键盘快捷键(Ctrl+V)把内容粘贴到方框里，按 确定",
      Blocktag: "段落标签",
      Fontface: "字体",
      FontSize: "字体大小",
      Bold: "加粗 (Ctrl+B)",
      Italic: "斜体 (Ctrl+I)",
      Underline: "下划线 (Ctrl+U)",
      Strikethrough: "删除线",
      FontColor: "字体颜色",
      BackColor: "背景颜色",
      SelectAll: "全选 (Ctrl+A)",
      Removeformat: "删除文字格式",
      Align: "对齐",
      List: "列表",
      Outdent: "减少缩进",
      Indent: "增加缩进",
      Link: "超链接 (Ctrl+L)",
      Unlink: "取消超链接",
      Anchor: "锚点",
      Img: "图片",
      Flash: "Flash动画",
      Media: "多媒体文件",
      Hr: "插入水平线",
      Emot: "表情",
      Table: "表格",
      Source: "源代码",
      WYSIWYG: "可视化编辑",
      Preview: "预览",
      Print: "打印 (Ctrl+P)",
      Fullscreen: "全屏编辑 (Esc)",
      About: "关于 xhEditor",

      dialogOk: "确定",
      dialogCancel: "取消",
      cutDisabledTip:
        "您的浏览器安全设置不允许使用剪切操作，请使用键盘快捷键(Ctrl + X)来完成",
      copyDisabledTip:
        "您的浏览器安全设置不允许使用复制操作，请使用键盘快捷键(Ctrl + C)来完成",
      pasteDisabledTip:
        "您的浏览器安全设置不允许使用粘贴操作，请使用键盘快捷键(Ctrl + V)来完成",
      close: "关闭",

      listFontname: [
        { n: "宋体", c: "SimSun" },
        { n: "仿宋体", c: "FangSong_GB2312" },
        { n: "黑体", c: "SimHei" },
        { n: "楷体", c: "KaiTi_GB2312" },
        { n: "微软雅黑", c: "Microsoft YaHei" },
        { n: "Arial" },
        { n: "Arial Black" },
        { n: "Comic Sans MS" },
        { n: "Courier New" },
        { n: "System" },
        { n: "Times New Roman" },
        { n: "Tahoma" },
        { n: "Verdana" },
      ],

      listBlocktag: {
        p: "普通段落",
        h1: "标题1",
        h2: "标题2",
        h3: "标题3",
        h4: "标题4",
        h5: "标题5",
        h6: "标题6",
        pre: "已编排格式",
        address: "地址",
      },

      fontsize: {
        "x-small": "极小",
        small: "特小",
        medium: "小",
        large: "中",
        "x-large": "大",
        "xx-large": "特大",
        "-webkit-xxx-large": "极大",
      },

      align: {
        justifyleft: "左对齐",
        justifycenter: "居中",
        justifyright: "右对齐",
        justifyfull: "两端对齐",
      },

      list: {
        insertOrderedList: "数字列表",
        insertUnorderedList: "符号列表",
      },

      link: {
        url: "链接地址: ",
        target: "打开方式: ",
        targetBlank: "新窗口",
        targetSelf: "当前窗口",
        targetParent: "父窗口",
        linkText: "链接文字: ",
        defText: "点击打开链接",
        anchor: "页内锚点: ",
        anchorNone: "未选择",
      },

      anchor: {
        name: "锚点名称: ",
      },

      img: {
        url: "图片文件: ",
        alt: "替换文本: ",
        align: "对齐方式: ",
        alignLeft: "左对齐",
        alignRight: "右对齐",
        alignTop: "顶端",
        alignMiddle: "居中",
        alignBaseline: "基线",
        alignBottom: "底边",
        width: "宽　　度: ",
        height: "高　　度: ",
        border: "边框大小: ",
        hspace: "水平间距: ",
        vspace: "垂直间距: ",
      },

      flash: {
        url: "动画文件: ",
        width: "宽　　度: ",
        height: "高　　度: ",
      },

      media: {
        url: "媒体文件: ",
        width: "宽　　度: ",
        height: "高　　度: ",
      },

      "emot.default": {
        smile: "微笑",
        tongue: "吐舌头",
        titter: "偷笑",
        laugh: "大笑",
        sad: "难过",
        wronged: "委屈",
        fastcry: "快哭了",
        cry: "哭",
        wail: "大哭",
        mad: "生气",
        knock: "敲打",
        curse: "骂人",
        crazy: "抓狂",
        angry: "发火",
        ohmy: "惊讶",
        awkward: "尴尬",
        panic: "惊恐",
        shy: "害羞",
        cute: "可怜",
        envy: "羡慕",
        proud: "得意",
        struggle: "奋斗",
        quiet: "安静",
        shutup: "闭嘴",
        doubt: "疑问",
        despise: "鄙视",
        sleep: "睡觉",
        bye: "再见",
      },

      table: {
        rows: "行　　数: ",
        columns: "列　　数: ",
        headers: "标题单元: ",
        headersRow: "第一行",
        headersCol: "第一列",
        headersBoth: "第一行和第一列",
        width: "宽　　度: ",
        height: "高　　度: ",
        border: "边框大小: ",
        cellSpacing: "表格间距: ",
        cellPadding: "表格填充: ",
        align: "对齐方式: ",
        alignLeft: "左对齐",
        alignCenter: "居中",
        alignRight: "右对齐",
        caption: "表格标题: ",
      },

      upload: {
        btnText: "上传",
        browserTitle: "浏览文件",
        progressTitle: "文件上传中(Esc取消上传)",
        progressTip: "文件上传中，请稍候……",
        countLimit: "请不要一次上传超过{$0}个文件",
        extLimit: "文件的扩展名必需为：{$0}",
        typeLimit: "每次只能拖放上传同一类型文件",
        apiError:
          "{$0} 上传接口发生错误！\r\n\r\n返回的错误内容为: \r\n\r\n{$1}",
      },

      aboutXheditor:
        'xhEditor是基于jQuery开发的跨平台轻量可视化XHTML编辑器，基于<a href="http://www.gnu.org/licenses/lgpl.html" target="_blank">LGPL</a>开源协议发布。',
    });
  }
}

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js